import request from "./../utils/request";
import { getChannelId } from "./../utils/channel";

export function getCustomLoginFormInputs() {
    const channelId = getChannelId();
    return request.get(`/public/loginForms/get-all?cache=true${channelId ? "&channel=" + channelId : ""}`);
}



// WEBPACK FOOTER //
// ./src/api/customLoginForm.js